export default "__VITE_ASSET__CwhkYZcr__"